import React from 'react';
import PropTypes from 'prop-types';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function UndoButton({ content, onClick, disabled }) {
  return (
    <CPButton
      title="Відмінити"
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faUndo}
    />
  );
}

UndoButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

UndoButton.defaultProps = {
  onClick: () => null,
  content: 'Відмінити',
  disabled: false,
};

export default UndoButton;
